import Icon from "core/assets/icons";
import { useEffect, useRef, useState } from "react";
import { useUser } from "modules/Auth/hooks";
import CReport from "../CReport";
import CDelete from "../CDeleteCommunity";

export type IProps = {
  className?: string;
  creatorId?: number;
  id?: number;
  type?: 'post' | 'comment';
  handleClick?: (e: any) => void;
};

const CDropdownComunity = ({
  className,
  creatorId,
  type = 'post',
  id,
  handleClick
}: IProps) => {

  const divRefDropDown = useRef<HTMLDivElement | null>(null);
  const [showDropDown, setShowDropDown] = useState<any>(false);

  const { userInfo } = useUser()

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      // Check if the click target is outside the div
      if (divRefDropDown.current && typeof divRefDropDown.current == 'object' && !divRefDropDown.current.contains(event.target)) {
        // console.log(id,'Clicked outside the div!', event.target.getAttribute('data-right'));
        if (event.target.getAttribute('data-right') && event.target.getAttribute('data-right').includes(id)) {
          // console.log('Clicked outside the div!',event.target.getAttribute('data-right'));
          setShowDropDown(true)
        } else {
          // console.log(id,'Clicked outside the div!', event.target);
          setShowDropDown(false)
        }

        // Perform your desired action here
      }
    };

    // Attach the event listener to the document
    document.addEventListener('click', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [id]);

  const handleAction = () => {
    setShowDropDown(false)
    // console.log(creatorId, id, 'handleToPage1', type)
    handleClick?.({id: id, action: (userInfo?.id && userInfo?.id === creatorId ? 'DELETE' : 'REPORT')})
  }
  const handleClose = () => {
    setShowDropDown(false)
  }

  if(!userInfo?.id) return null
  return (<>
    <div className={`relative text-right inline-block ${className}`}>
      <div className=''>
        <img className="icon-right" src={Icon.SettingDropDown} data-right={`true-${id}`} alt="" />
      </div>
      <div className={`
      dropdown-more-action 
      border border-[#eeeeee] 
      bg-white 
      px-5 
      py-1.5 
      text-right 
      rounded-lg 
      w-auto 
      bg-white 
      z-[99] 
      absolute 
      right-[10px] 
      top-[25px] 
      rounded-lg  
      ${showDropDown ? 'inline-block' : 'hidden'}`}
        ref={divRefDropDown}>
        <ul>

          {userInfo?.id && userInfo?.id === creatorId ? <li className="text-[13px] text-[#333333] whitespace-nowrap">
            <CDelete type={type} handleClick={handleAction}  onClose={handleClose} creatorId={creatorId} id={id} />
          </li> : <li className="text-[13px] text-[#333333] whitespace-nowrap" >
            <CReport type={type} handleClick={handleAction} onClose={handleClose} creatorId={creatorId} id={id} />
          </li>}

        </ul>
      </div>
    </div>
  </>)
}

export default CDropdownComunity;